import { render, staticRenderFns } from "./MicroHistogram.vue?vue&type=template&id=31f92048&scoped=true&"
import script from "./MicroHistogram.vue?vue&type=script&lang=js&"
export * from "./MicroHistogram.vue?vue&type=script&lang=js&"
import style0 from "./MicroHistogram.vue?vue&type=style&index=0&id=31f92048&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f92048",
  null
  
)

export default component.exports